var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav-bar'),_c('error-info'),_c('site-footer-details',{attrs:{"show-subscribe":true}}),_c('copyright')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }